export default {"src":"/_next/static/media/befree.c21fcbaf.svg","height":450,"width":600,"blurWidth":0,"blurHeight":0};